import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';
import { compare, SortEvent, tableActions, tableBodyItems, tableButtons, TableCellData, TableConfigs, tableHeaderItems } from './table';
import { TableDirective } from './table.directive';
import { chunk, get, isNil, orderBy, kebabCase, camelCase, template, uniqBy } from "lodash-es";

@Component({
  selector: 'app-table',
  templateUrl: './table.component.html',
  styleUrls: ['./table.component.scss']
})
export class TableComponent implements OnInit {

  @Input() search: string;
  @Input() tableHeaderItems: Array<tableHeaderItems> = [];
  @Input() tableFilterText = [];
  @Input() tableConfigs: TableConfigs = {
    selectedAll: false,
    order: true,
    pagination: false,
    showHeader: true,
    search: false,
    searchField: ['nome', 'email'],
    currentPage: 1,
    itemsPerPage: 8,
    total: {
      view: false,
      text: ''
    }
  };
  @Input() tableBodyItems = [];
  @Input() hasSelect = false;
  @Input() tableItems = [];
  allSelected: boolean = false;
  @Input() $buttons: Array<tableButtons> = [];
  load: boolean = true;
  @Output() action: EventEmitter<tableActions> = new EventEmitter<tableActions>();

  @ViewChildren(TableDirective) headers: QueryList<TableDirective>;

  currentPage: number = this.tableConfigs?.currentPage;
  itemsPerPage: number = this.tableConfigs?.itemsPerPage;
  pageSize: number;
  constructor() {
  }

  ngOnInit() {
    // this.tableItems = this.buildData(this.tableHeaderItems);
  }

  get data() {
    return this.tableBodyItems;
  }
  onSort({ column, direction }: SortEvent) {
    //resetar a orderm dos headers
    this.headers.forEach(header => {
      if (header.sortable !== column) {
        header.direction = 'asc';
      }
    });

    if (column === '') {
      this.tableItems = this.tableItems;
    } else {
      this.tableItems = [...this.tableItems].sort((a, b) => {
        const result = compare(a[column], b[column]);
        return direction === 'asc' ? result : -result;
      });
    }
  }

  onPageChange(pageNum: number): void {
    this.pageSize = this.pageSize * (pageNum - 1);
  }

  changePagesize(num: number): void {
    this.itemsPerPage = this.pageSize + num;
  }

  linkAndButtonAction(data: any, action: string, isLink?: boolean) {
    if (isLink) {
      return action;
    }
    this.action.emit({ action, data });
  }

  toggleGroupSelect() {
  }

  trackCol(item: tableHeaderItems) {
    return item ? item.field : null;
  }

  itemClick(event, item) {
    try {
      if (this.hasSelect && event.target.tagName === "TD") {
        item.toggleSelect();
      }
    } catch (e) {

    }

  }
}
